import React from 'react';
import { Helmet } from "react-helmet";
import Spinner from '../../audi-ui-components/Spinner';
import Layout from '../../components/Layout';
import Location from './components/Location';
import Frame from './components/Frame';
import SearchForm from './components/SearchForm';
import List from './components/List';
import API from '../../functions/api';
import queryString from 'query-string';
import { gtmPageview, gtmPush } from '../../functions/gtm';
import {
    UI_AUDI,
    DEFAULT_THEME,
} from '../../constants';
import "./locate.scss";

class LocateARepairer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            list: [],
            filteredRepairers: null,
            selectedRepairer: null,
            searchError: null
        }
    }

    componentDidMount() {
        gtmPageview(this.props.location.pathname);
        API.post(
          process.env.RAZZLE_GQLAPI,
          {
            query: /* GraphQL */`query ($filter: LocationDtoFilterInput) {
              locationList(skip: 0, take: 50, where: $filter) {
                items {
                  id
                  type
                  address
                  email
                  latitude
                  longitude
                  mapsURL
                  message
                  name
                  phone
                  postcode
                  state
                  suburb
                  website
                  monday
                  tuesday
                  wednesday
                  thursday
                  friday
                  saturday
                  sunday
                }
              }
            }`,
            variables: {
              filter: {type: {eq: "RepairCentre"}, status: {eq: true}}
            }
          }
        ).then(response => {
            // console.log(response);
            let items = response.data?.data?.locationList?.items
            this.setState({list: items, loading: false});
        }).catch(err => {
            console.error(err);
            this.setState({loading: false, searchError: "An error has occured"});
        });
    }

    trackEvent = (eventName, data) => {
        // thneed.trigger(eventName, 'locateARepairCentre', data, true);
        gtmPush("locateARepairCentre", eventName, "locateARepairCentre", data);
    }

    handleSearchSubmit = (data) => {
        const {list} = this.state;
        this.trackEvent('searchSubmit', data);
        var filtered = [];
        if (list && list.length > 0) {
            filtered = list.filter(
                d => d.state === data.state
            );
        }
        if (filtered.length === 1) {
            this.handleSelect(filtered[0]);
            this.setState({searchError: null});
        } else if (filtered.length > 1) {
            this.setState({filteredRepairers: filtered, searchError: null});
        } else {
            this.setState({searchError: "There are no repairers in that state"})
        }
    }

    getBackButtonText = () => {
        if (this.state.selectedRepairer && this.state.filteredRepairers) {
            return 'Back to results';
        } else if (this.state.filteredRepairers || this.state.selectedRepairer) {
            return 'Back to search';
        }
        return null;
    }

    handleBackClick = () => {
        if (this.state.selectedRepairer) {
            return this.setState({selectedRepairer: null});
        }
        return this.setState({filteredRepairers: null});
    }

    getMapRepairers = () => {
        if (this.state.selectedRepairer) {
            return [this.state.selectedRepairer];
        } else if (this.state.filteredRepairers) {
            return this.state.filteredRepairers;
        }
        return this.state.list;
    }

    handleSelect = (rep) => {
        this.setState({selectedRepairer: rep});
        this.trackEvent('selectRepairCentre', {repairCentreName: rep.name});
    }

    renderInner = (theme) => {
        const {selectedRepairer} = this.state;
        if (selectedRepairer) {
            return (
                <Location
                    key={selectedRepairer.id}
                    trackEvent={(e) => { this.trackEvent(`repairCentre${e}`, {repairCentreName: selectedRepairer.name, location: selectedRepairer.type}); }}
                    {...selectedRepairer}
                    theme={theme}
                />
            );
        } else if (this.state.filteredRepairers) {
            return (
                <List
                    locations={this.state.filteredRepairers}
                    onClick={this.handleSelect}
                />
            );
        }
        return (
            <SearchForm
                onSubmit={this.handleSearchSubmit}
                searchBy="state"
                lockSearchBy
                onChangeState={(s) => { this.trackEvent('selectRepairCentreState', {state: s}); }}
                error={this.state.searchError}
                theme={theme}
            />
        );
    }

    render() {
        const query = queryString.parse(this.props.location.search);
        const theme = query.theme || DEFAULT_THEME;
        const {filteredRepairers, selectedRepairer, loading} = this.state;

        return (
            <Layout ui={query.ui || UI_AUDI} embedded={query.embedded} wide={query.wide} theme={theme}>
                <Helmet>
                    <title>Find an authorised repairer | Audi Australia</title>
                </Helmet>

                <main className="audi-forms__page locate">

                    {loading && <div className="spinner-wrapper"><Spinner isContinuous /></div>}

                    <Frame title="Find an authorised repairer"
                        locations={this.getMapRepairers()}
                        onClick={this.handleSelect}
                        backButtonText={this.getBackButtonText()}
                        onBackClick={this.handleBackClick}
                    >
                        {this.renderInner(theme)}
                    </Frame>

                </main>
            </Layout>
        );
    }
}

export default LocateARepairer;
